import matrixFunctions from './matrixFunctions';

export const getMergedCells = (data) => {
  const allCells = matrixFunctions.getAllCells(data);
  return allCells
    .filter(f => f.cell.colSpan || f.cell.rowSpan)
    .map(f => ({
      parent: f,
      cells: allCells.filter(g => isBetween(g.rowInd, f.rowInd, f.rowInd + (f.cell.rowSpan || 1) - 1) && isBetween(g.colInd, f.colInd, f.colInd + (f.cell.colSpan || 1) - 1)),
    }));
};

export const isBetween = (val, from, to) => val >= from && val <= to;

// export const parseTableData = response => {
//   const data = response.content.map(f => f.map(g => ((g || {}).value !== undefined ? g : { value: g })));
//   response.config.mergeCells.forEach(f => data[f.row][f.col] = { ...data[f.row][f.col], rowSpan: f.rowspan, colSpan: f.colspan });

//   const styleTranslator = classToStyleTranslator();
//   response.config.cell
//     .filter(f => f.row != null && f.col != null) // eslint-disable-line
//     .forEach(f => data[f.row][f.col].style = {
//       ...data[f.row][f.col].style,
//       ...f.className.split(' ').reduce((acc, key) => Object.assign(acc, styleTranslator[key]), {}),
//       ...(f.style || {}),
//     });

//   return {
//     ...response,
//     data: {
//       data,
//       rows: response.config.rowHeights.map((height, ind) => ({ height, fixed: ind < response.config.fixedRowsTop })),
//       columns: response.config.colWidths.map((width, ind) => ({ width, fixed: ind < response.config.fixedColumnsLeft })),
//     },
//     config: undefined,
//     content: undefined,
//   };
// };

export const getTableCells = table => {
  if (!table) return [[]];

  return Array.from(table.getElementsByTagName('tr'))
    .map(f => Array.from(f.children));
};

export const defaultWidth = 100;
export const defaultHeight = 30;

export const getPastedObject = event => {
  var htmlData = (event.clipboardData.getData('text/html') || '').replace('<!--', '').replace('-->', '');

  var div = document.createElement('div');
  div.style.position = 'fixed';
  div.style.top = '500px';
  div.style.left = '100px';
  div.innerHTML = htmlData;

  var table = div.getElementsByTagName('table')[0];
  if (!table) return null;

  const getTableCells = table => {
    if (!table) return [[]];

    return Array.from(table.getElementsByTagName('tr'))
      .map(f => Array.from(f.children));
  };

  // table.className = `pastetable ${table.className}`;
  // document.body.appendChild(div);
  var cells = getTableCells(table);
  // var availableStyles = toKeyValue(classToStyleTranslator())
  //   .map(f => toKeyValue(f.value)[0]);

  // var isInline = el => !el.tagName || getComputedStyle(el).display.indexOf('inline') > -1;
  var isEmptyNode = el => !el.tagName && !el.textContent.trim();
  // var hasNewLine = (el1, el2) => !isEmptyNode(el2) && !(isInline(el1) && isInline(el2));
  var getNodeText = node => node.textContent.replace(/(\s+)/g, ' ');
  var getText = element => {
    if (!element.childElementCount)
      return element.tagName === 'BR' ? '\n' : element.innerText;
    var children = Array.from(element.childNodes).filter((g, ind) => (ind === 0 && !isEmptyNode(g)) || (ind > 0 && !(isEmptyNode(g) && isEmptyNode(element.childNodes[ind - 1]))));
    return children.map(g => `${g.tagName ? getText(g) : getNodeText(g)}`).join('');
  };

  // var getLastFirstChildNode = element => {
  //   var childNodes = Array.from(element.childNodes).filter(f => f.textContent.trim());
  //   return childNodes[0] ? getLastFirstChildNode(childNodes[0]) : element;
  // };

  var pasted = cells.map(f => f.map(cell => {
    // var lastNode = getLastFirstChildNode(cell);
    // var computedStyle = {
    //   ...getComputedStyle(lastNode.tagName ? lastNode : lastNode.parentElement),
    //   ...getObjectFromProps(getComputedStyle(cell), ['verticalAlign']),
    // };

    // var style = availableStyles.filter(h => computedStyle[h.key] == h.value).reduce((acc, h) => { acc[h.key] = h.value; return acc; }, {}); // eslint-disable-line
    // style.backgroundColor = cell.style.backgroundColor || cell.parentNode.style.backgroundColor;

    return {
      value: getText(cell).trim().replace(/(\n\s+)/g, '\n').replace(/(\s+\n)/g, '\n'),
      // style,
      ...(cell.rowSpan > 1 || cell.colSpan > 1 ? { rowSpan: cell.rowSpan, colSpan: cell.colSpan } : {}),
    };
  }));

  var allCells = matrixFunctions.getAllCells(pasted);
  var merged = allCells.filter(g => g.cell.rowSpan).sortBy(f => f.colInd);
  const isBetween = (val, from, to) => val >= from && val <= to;
  merged.forEach(f => {
    allCells
      .filter(g => f !== g && isBetween(g.rowInd, f.rowInd, f.rowInd + f.cell.rowSpan - 1) && g.colInd >= f.colInd)
      .forEach(g => g.colInd += f.cell.colSpan - (f.rowInd === g.rowInd ? 1 : 0));
  });

  var rowCount = allCells.max(f => f.rowInd + (f.cell.rowSpan || 1));
  var colCount = allCells.max(f => f.colInd + (f.cell.colSpan || 1));

  var data = matrixFunctions.create(rowCount, colCount).map(f => f.map(() => ({ value: null })));
  allCells.forEach(f => data[f.rowInd][f.colInd] = f.cell);

  // var rows = cells.map(f => ({ height: f.any() ? f[0].parentNode.offsetHeight : 0 }));
  // var columns = cells.find(f => f.length === cells.max(g => g.length)).map(f => ({ width: f.offsetWidth }));

  // document.body.removeChild(div);
  return { data }; // , rows, columns };
};